import { MachineAuditService } from '@src/framework/workbench/common/service/machine-audit-service';
import { FIXED_KEYS_DOUBLE } from '@src/framework/workbench/schema/constant';
import { getPcInjectedService } from '@src/framework/workbench/util/injector-service';
import { getToggleStatusByType, ToggleType } from '@src/slide/infrastructure/module/dependent/config/toggle-config';
import { Controller, Toolbar } from '@tencent/workbench';
import { MachineAuditFeature } from './machine-audit-feature';

@Controller({
    toolbarItems: [],
})
export class MachineCheckController {
    private isShowMachineCheck = false;
    public constructor(private readonly feature: MachineAuditFeature) {
        this.isShowMachineCheck = !!getToggleStatusByType(ToggleType.TEMPLATE_CHECK_BUTTON);
        if (this.isShowMachineCheck) {
            const machineCheckService = getPcInjectedService(MachineAuditService) as MachineAuditService;
            machineCheckService.updateController();
        }
    }

    @Toolbar(FIXED_KEYS_DOUBLE.TOOLBAR_MACHINE_AUDIT, 'shouldHide')
    public shouldHideMachineCheck() {
        return !this.isShowMachineCheck;
    }

    @Toolbar(FIXED_KEYS_DOUBLE.TOOLBAR_MACHINE_AUDIT, 'onClick')
    public onClickMachineCheck() {
        this.feature.showTemplateMachineCheck();
    }
}
